<template>
  <div v-if="sidebar_org_id">
    <v-navigation-drawer id="nav-drawer" v-model="drawer" color="secondary" app>
      <!-- sidebar 頂部 -->
      <template #prepend>
        <!-- 商店的menu -->
        <v-menu v-model="is_show_parent_menu" offset-y>
          <template #activator="{ on }">
            <v-list-item else link v-on="on" @click="openParentMenu">
              <v-avatar tile class="mr-3">
                <v-img src="@/assets/logo.png" />
              </v-avatar>

              <v-list-item-content>
                <v-list-item-title class="text-h6 white--text">
                  {{ getOrganizeName($route.params.org_id) }}
                </v-list-item-title>

                <v-list-item-subtitle v-if="selectedContainer !== null" class="white--text">
                  {{ selectedContainer.name }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-else class="white--text" v-text="$t('layout_appSidebar.noContainer')" />
              </v-list-item-content>

              <v-list-item-action v-if="organizations.length !== 0">
                <v-icon color="white" v-text="'mdi-chevron-down'" />
              </v-list-item-action>
            </v-list-item>
          </template>

          <v-list>
            <v-list-item
              v-for="org_item in organization_containers"
              :key="org_item.org_id"
              class="parent-item"
              dense
              @click.stop.prevent="() => {}"
              @mouseover="displaySubMenu(org_item, organization_containers)"
            >
              <v-list-item-title>
                {{ `${org_item.org_name}` }}
              </v-list-item-title>

              <v-menu
                v-model="org_item.is_show_containers"
                offset-x
                max-width="300"
                min-width="200"
                :close-on-click="false"
              >
                <template #activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    @mouseover="displaySubMenu(org_item, organization_containers)"
                    v-on="on"
                    v-text="'mdi-chevron-right'"
                  />
                </template>
                <v-list max-height="500" class="overflow-y-auto">
                  <template v-for="subItem in org_item.containers">
                    <v-list-item
                      v-if="subItem.id !== 'new'"
                      :key="subItem.id"
                      class="sub-item"
                      dense
                      @click="changeContainer(org_item, subItem)"
                    >
                      <v-list-item-title> {{ subItem.name }} </v-list-item-title>
                    </v-list-item>

                    <v-list-item v-else :key="`${subItem.id}_1`" dense class="sub-item">
                      <v-btn
                        block
                        class="white--text"
                        color="#5087e6"
                        @click="goContainerPage(org_item)"
                        v-text="$t('common.create')"
                      />
                    </v-list-item>
                  </template>
                </v-list>
              </v-menu>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- 功能列表 Start -->
        <v-list dense nav link>
          <template v-for="(item, i) in routes">
            <v-list-group
              v-if="
                (item.invisibility_sidebar === undefined || item.invisibility_sidebar === false) &&
                (!item.show_levels || item.show_levels.includes(quota_info[sidebar_org_id].level)) &&
                checkShowFeature(item, user_info)
              "
              :key="i"
              no-action
              eager
              color="white"
              :value="isOpen($route.path, item.feature)"
            >
              <template #activator>
                <v-list-item-icon class="mr-4" color="white">
                  <v-icon
                    class="white--text"
                    :class="$route.path.indexOf(item.feature) !== -1 ? 'item-activate-text-background' : ''"
                    v-text="item.icon"
                  />
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title
                    class="white--text"
                    :class="$route.path.indexOf(item.feature) !== -1 ? 'item-activate-text-background' : ''"
                    v-text="item.name"
                  />
                </v-list-item-content>
              </template>

              <template v-for="(child, i) in item.children">
                <v-list-item
                  v-if="
                    (child.invisibility_sidebar === undefined || child.invisibility_sidebar == false) &&
                    (!child.show_levels || child.show_levels.includes(quota_info[sidebar_org_id].level))
                  "
                  :key="i"
                  link
                  style="padding: 0 0 0 2.25rem; margin-bottom: 0"
                  :class="isActivateFeature(child)"
                  @click="goFeaturePage(child)"
                >
                  <div v-if="child.feature !== ''">
                    <v-list-item-content style="padding: 12px 0 12px 1rem; border-left: 1px solid #fff">
                      <v-list-item-title
                        class="white--text"
                        :class="$route.path.indexOf(child.feature) !== -1 ? 'item-activate-text' : ''"
                      >
                        {{ `${child.name}` }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </div>
                </v-list-item>
              </template>

              <template #appendIcon>
                <v-icon color="white" v-text="'mdi-chevron-down'" />
              </template>
            </v-list-group>
          </template>
        </v-list>
      </template>

      <template #append>
        <!-- 組織設定 Start -->
        <Submenu
          v-if="!$auth_helper.isContainerUser(user_info, selectedOrg.org_id)"
          :item="orgnize_setting_item"
          :activate_setting="submebu_activate_setting"
          @selectItem="goSettingPage"
        />
      </template>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-app-bar-nav-icon @click="toggleDrawer" />
      <!-- 有設定麵包屑的話，用麵包屑的樣式 -->
      <template v-if="$route.meta.breadcrumbs !== undefined && $route.meta.breadcrumbs.length !== 0">
        <template v-if="$store.getters.replace_breadcrumbs && $store.getters.replace_breadcrumbs.length !== 0">
          <v-breadcrumbs class="pl-0" large :items="$store.getters.replace_breadcrumbs">
            <template #item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled" class="d-flex align-center">
                {{ item.text }}
                <v-icon v-if="item.icon" class="ml-2" @click="item.callback" v-text="item.icon" />
              </v-breadcrumbs-item>
            </template>
            <template #divider>
              <v-icon v-text="'mdi-chevron-right'" />
            </template>
          </v-breadcrumbs>
        </template>

        <template v-else>
          <v-breadcrumbs class="pl-0" large :items="$route.meta.breadcrumbs">
            <template #divider>
              <v-icon v-text="'mdi-chevron-right'" />
            </template>
          </v-breadcrumbs>
        </template>
      </template>

      <!-- 沒設定麵包屑的話，顯示名字 -->
      <template v-else>
        <v-toolbar-title v-text="$route.name" />
      </template>

      <v-spacer />

      <v-alert
        v-if="quota_info[sidebar_org_id].level === 'disable'"
        type="warning"
        color="warning"
        class="my-2 mr-3"
        icon="mdi-alert"
        style="font-size: 14px; cursor: pointer"
        dense
        @click="$router.push(`/${sidebar_org_id}/setting/subscription/`)"
        v-html="$t('layout_appSidebar.planExpiredAlert')"
      />

      <v-alert
        v-if="
          getRemainingdays(quota_info[sidebar_org_id]) <= subscription_thredhold &&
          quota_info[sidebar_org_id].level !== 'disable' &&
          quota_info[sidebar_org_id].sub_end_at
        "
        type="warning"
        color="info"
        class="my-2 mr-3"
        icon="mdi-information"
        style="font-size: 14px; cursor: pointer"
        dense
        @click="$router.push(`/${sidebar_org_id}/setting/subscription/`)"
        v-html="$t('layout_appSidebar.remainingTimeAlert', { days: getRemainingdays(quota_info[sidebar_org_id]) })"
      />

      <v-badge
        class="mr-5"
        color="error"
        overlap
        :content="notify_setting.total_size"
        :value="notify_setting.total_size"
      >
        <v-icon large @click="showAllNotify('unread')" v-text="'mdi-bullhorn-outline'" />
      </v-badge>

      <!-- i18n 尚未完成，先關閉切換語系 -->
      <v-select
        v-if="false"
        v-model="select_lang"
        class="lang-selector flex-grow-0"
        solo
        dense
        hide-details
        menu-props="bottom, offset-y"
        background-color="#f5f5f5"
        :items="lang_list"
        @change="changeLanguage"
      />

      <!-- 使用者圖標icon -->
      <v-menu bottom min-width="200px" rounded offset-y :close-on-content-click="false">
        <template #activator="{ on }">
          <div v-on="on">
            <v-avatar color="grey darken-1" size="32" class="mr-1" style="cursor: pointer">
              <v-icon dark v-text="'mdi-account-circle'" />
            </v-avatar>
            <strong style="cursor: pointer">
              {{ user_info.user_name }}
            </strong>
          </div>
        </template>

        <v-card>
          <v-list>
            <v-list-item class="flex-column mt-3" style="gap: 12px; min-height: auto">
              <v-avatar color="grey darken-1">
                <v-icon dark v-text="'mdi-account-circle'" />
              </v-avatar>
              <h4 v-text="user_info.user_name" />
              <div class="mb-0 pb-0" v-text="user_info.email"></div>
            </v-list-item>

            <template v-for="(key, index) in Object.keys(user_menu)">
              <v-list-group v-if="user_menu[key].list && !user_menu[key].hidden" :key="index" no-action color="#7B3AED">
                <template #activator>
                  <v-list-item-icon v-if="user_menu[key].icon">
                    <v-icon v-text="user_menu[key].icon" />
                  </v-list-item-icon>
                  <v-list-item-title v-text="user_menu[key].title" />
                </template>

                <v-list-item
                  v-for="(child_item, child_index) in user_menu[key].list"
                  :key="child_index"
                  color="#7B3AED"
                  dense
                  :to="child_item.to"
                >
                  <v-list-item-title v-text="child_item.title" />
                  <v-list-item-icon v-if="child_item.icon">
                    <v-icon v-text="child_item.icon" />
                  </v-list-item-icon>
                </v-list-item>
              </v-list-group>

              <v-list-item
                v-else-if="!user_menu[key].hidden"
                :key="`${index}_1`"
                link
                dense
                color="#7B3AED"
                :to="user_menu[key].to"
              >
                <v-list-item-icon v-if="user_menu[key].icon">
                  <v-icon v-text="user_menu[key].icon" />
                </v-list-item-icon>
                <v-list-item-title v-text="user_menu[key].title" />
              </v-list-item>
            </template>

            <v-divider />

            <v-list-item dense @click="logout()">
              <v-list-item-title class="d-flex justify-center align-center" v-text="$t('common.logout')" />
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-dialog
      v-if="notify_setting.is_show"
      v-model="notify_setting.is_show"
      width="900"
      @click:outside="notify_setting.is_show = false"
    >
      <v-card :key="notify_setting.tab">
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t('common.notification') }}
          <v-spacer />
          <v-btn icon @click="notify_setting.is_show = false">
            <v-icon v-text="'mdi-close'" />
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-4">
          <v-tabs v-model="notify_setting.tab" fixed-tabs background-color="white" class="full-tabs">
            <v-tabs-slider />
            <v-tab href="#unread" @click="getNotify('unread', 1)">{{ $t('common.unresolved') }}</v-tab>
            <v-tab href="#read" @click="getNotify('read', 1)">{{ $t('common.resolved') }}</v-tab>
          </v-tabs>
          <v-card>
            <v-data-table
              fixed-header
              hide-default-footer
              height="50vh"
              sort-by="timestamp"
              sort-desc
              :loading="notify_setting.loading"
              :loading-text="notify_setting.loading_text"
              :headers="notify_setting.headers"
              :items="notify_setting.items"
              :no-data-text="notify_setting.no_data_text"
              :items-per-page="notify_setting.items.length"
            >
              <template #[`item.push_status`]="{ item }">
                <template v-if="item.push_status === -1">
                  <div class="d-flex">
                    <v-icon small color="primary" class="mr-2" v-text="'mdi-information-outline'" />
                    <span>{{ $t('layout_appSidebar.notificationError') }}</span>
                  </div>
                </template>
                <template v-else-if="item.push_status === 1">
                  <div class="d-flex">
                    <v-icon small color="success" class="mr-2" v-text="'mdi-send-check-outline'" />
                    <span>{{ $t('common.notified') }}</span>
                  </div>
                </template>
              </template>
              <template #[`item.feature_name`]="{ item }">
                <v-chip class="ma-2" color="purple" text-color="white" label>
                  {{ notify_setting.feature_name_mapper[item.feature_name] }}
                </v-chip>
              </template>
              <template #[`item.actions`]="{ item }">
                <div class="d-flex justify-end">
                  <v-btn
                    color="grey"
                    class="white--text"
                    @click="goNotifyPlace(item)"
                    v-text="$t('common.viewDetails')"
                  />
                  <v-btn color="primary" class="ml-3" @click="read(item)" v-text="$t('common.resolved')" />
                </div>
              </template>
            </v-data-table>
          </v-card>

          <div class="text-center mt-5">
            <Pagination v-if="notify_setting.is_show" :setting="notify_setting" @changePage="notifyPageCallback" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Submenu from '@/components/Utils/Submenu'
import Pagination from '@/components/Utils/Pagination.vue'
import { apiGetSubscriptionInfo } from '@/api/organize.js'
import { apiGetContainerNotifyV2, apiReadNotify } from '@/api/notify.js'
import { apiUseApiAuth } from '@/api/user.js'
import { private_routes } from '@/routes/private_routes.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    Submenu,
    Pagination,
  },
  data() {
    return {
      // 左上角漢堡
      drawer: true,
      // 有哪些功能，用routes來產sidebar的item
      routes: [],
      // 左上角組織選單的陣列
      organization_containers: [],
      // 是否顯示左上角的組織選單
      is_show_parent_menu: false,
      activate_feature: null,
      // 是否顯示左下角的設定選單
      is_show_org_parent_menu: false,
      orgnize_setting_item: {
        icon: 'mdi-cog',
        title: this.$t('common.organizationSettings'),
        sub_items: [
          {
            title: this.$t('common.organization'),
            value: 'organization',
          },
          {
            title: this.$t('common.member'),
            value: 'staffs',
          },
          {
            title: this.$t('common.container'),
            value: 'containers',
          },
          {
            title: this.$t('common.subscription'),
            value: 'subscription',
          },
        ],
      },
      submebu_activate_setting: {
        activate_path: 'setting',
        background_color: '#FFFFFF',
        text_color: '#353f4d',
      },
      subscription_thredhold: process.env.VUE_APP_SUBSCRIPTION_EXPIRED_DAY,
      side_bar_bottom_items: [],
      notify_setting: {
        is_show: false,
        tab: null,
        items: [],
        page: 1,
        limit: 20,
        selected_page: 1,
        total_page: 0,
        total_size: 0,
        total_visible: 10,
        loading: false,
        loading_text: this.$t('common.loading'),
        no_data_text: this.$t('layout_appSidebar.noRecords'),
        is_ignore_query: true,
        headers: [
          { text: this.$t('layout_appSidebar.notificationStatus'), value: 'push_status', sortable: false },
          { text: this.$t('layout_appSidebar.event'), value: 'feature_name', sortable: false },
          { text: this.$t('layout_appSidebar.source'), value: 'trigger_from', sortable: false },
          { text: this.$t('layout_appSidebar.eventTime'), value: 'created_at', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ],
        feature_name_mapper: {
          dynamicViewError: this.$t('layout_appSidebar.experimentError'),
          loginFail: this.$t('common.loginError'),
        },
        update_duration_sec: 600,
        update_timer: null,
      },
      sidebar_org_id: '',
      // 要 group 就帶 list, 有隱藏需求帶 hidden,
      user_menu: {
        partner: {
          hidden: !(this.$store.getters.loggedInfo.is_beta_user || this.$store.getters.loggedInfo.is_partner_user),
          title: this.$t('layout_appSidebar.collaborationFeature'),
          icon: 'mdi-handshake',
          list: [
            {
              title: this.$t('layout_appSidebar.frontendDescriptionSettings'),
              to: `/${this.$route.params.org_id}/${this.$route.params.container_id}/partner/readme_map`,
            },
          ],
        },
      },
      select_lang: localStorage.getItem('locale_lang') || this.$i18n.locale,
      lang_list: [],
    }
  },
  computed: {
    user_info() {
      return this.$store.getters.loggedInfo
    },
    organizations() {
      return this.$store.getters.loggedInfo.organizations
    },
    selected_organize() {
      return this.$store.getters.selectedOrg
    },
    quota_info() {
      return this.$store.getters.memberQuota
    },
    ...mapGetters(['organize_container_mapper', 'selectedOrg', 'selectedContainer', 'is_show_drawer']),
  },
  watch: {
    drawer(newVal) {
      this.$store.commit('setIsShowDrawer', newVal)
    },
  },
  async created() {
    this.getLangList()
    this.routes = this.routes.map((item) => {
      return {
        ...item,
        children: item.children !== undefined ? item.children.filter((child) => child.feature !== '') : item.children,
      }
    })

    this.side_bar_bottom_items.push(this.routes.find((item) => item.is_sidebar_bottom))
    if (!this.organize_container_mapper) {
      this.$router.push('/login')
      return
    }
    this.organization_containers = this.initOrganizeMenu(this.organize_container_mapper)
    this.drawer = this.is_show_drawer
    this.getNotify()
    this.createSidebarItem()
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearInterval(this.update_timer)
        this.update_timer = null
      } else {
        this.getNotify()
        this.update_timer = setInterval(() => {
          this.getNotify()
        }, 1000 * this.notify_setting.update_duration_sec)
      }
    })
  },
  mounted() {
    let org_id = ''
    const match = window.location.href.match(/https?:\/\/[^/]+\/([^/]+)/)
    org_id = match ? match[1] : null
    if (org_id && org_id.length === 32) {
      this.getQuota(org_id)
    }

    this.$root.vnotify = this.getNotify
  },
  methods: {
    getLangList() {
      for (const lang in this.$i18n.messages) {
        this.lang_list.push({ text: this.$i18n.t('common.lang_name', lang), value: lang })
      }
    },
    // 左上角的下拉選單
    initOrganizeMenu(organize_container_mapper) {
      organize_container_mapper = JSON.parse(JSON.stringify(organize_container_mapper))
      let menu_items = []
      Object.keys(organize_container_mapper).forEach((org_id) => {
        let tmp_item = {}
        let org = organize_container_mapper[org_id].organization
        tmp_item['org_id'] = org.org_id
        tmp_item['org_name'] = org.org_name
        tmp_item['org_role'] = org.org_role
        tmp_item['is_show_containers'] = false
        tmp_item['containers'] = organize_container_mapper[org_id].containers

        let is_container_user = this.$auth_helper.isContainerUser(this.user_info, org.org_id)
        if (!is_container_user) {
          tmp_item['containers'].push({
            id: 'new',
            name: this.$t('layout_appSidebar.createContainer'),
          })
        }

        menu_items.push(tmp_item)
      })

      return menu_items
    },
    // 登出
    logout() {
      let confirm_dialog = confirm(this.$t('common.logoutConfirm'))
      if (confirm_dialog) {
        localStorage.clear()

        if (process.env.VUE_APP_MODE === 'production') {
          window.location.href = process.env.VUE_APP_HOME_PAGE + '/signout'
        } else {
          this.$router.push('/login')
        }
      }
    },
    // 換container
    async changeContainer(org_item, container) {
      // 換container的話，換到首頁
      this.$store.commit('selected_container', container)
      this.$store.commit('select_organize', org_item)
      let path = ''

      if (this.$route.params.container_id) {
        if (this.activate_feature) {
          path = `/${org_item.org_id}/${container.id}/${this.activate_feature.link_path}`
        } else {
          path = `/${org_item.org_id}/${container.id}/home`
        }
      } else {
        path = this.$route.path.replace(this.$route.params.org_id, org_item.org_id)
      }
      try {
        await this.$router.push(path)
      } catch (error) {
        console.log(error)
      }
      this.is_show_parent_menu = false
      this.getQuota(org_item.org_id)
      this.getNotify()
      this.createSidebarItem()
    },
    // 用網址路徑來判斷是否要預先展開sidebar的功能列表
    // 例如: 網址帶有marketing-card，這樣一進來頁面就會預先展開這個功能的選單
    isOpen(now_path, feature) {
      return now_path.includes(feature)
    },
    // 點sidebar的功能時，跳轉到該頁
    goFeaturePage(route_item) {
      if (!this.selectedContainer) {
        return this.$root.vtoast.show({
          message: this.$t('layout_appSidebar.pleaseSelectContainerFirst'),
        })
      }

      try {
        this.$router.push('/' + this.selectedOrg.org_id + '/' + this.selectedContainer.id + '/' + route_item.link_path)
      } catch (error) {
        console.error('error', error.name)
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      }
    },
    // 控制左上角組織選單是否要開啟
    openParentMenu() {
      this.is_show_parent_menu = true
    },
    // 左上角組織選項顯示子選項
    displaySubMenu(item, items) {
      items.forEach((menu_item) => {
        if (menu_item.org_id !== item.org_id) {
          menu_item.is_show_containers = false
        }
      })
      item.is_show_containers = true
    },
    goContainerPage(org_item) {
      this.is_show_parent_menu = false
      try {
        // 如果去新增container的org跟目前不一樣的話，要更新選的org
        if (org_item.org_id !== this.$route.params.org_id) {
          this.$store.commit('select_organize', org_item)
          if (org_item.containers.length !== 0 && org_item.containers[0].id !== 'new') {
            this.$store.commit('selected_container', org_item.containers[0])
          } else {
            this.$store.commit('selected_container', null)
          }
        }

        this.$router.push({ path: '/' + org_item.org_id + '/setting/containers/' })
      } catch (error) {
        console.error('error', error.name)
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      }
    },
    isActivateFeature(child) {
      if (this.$route.path.indexOf(child.feature) !== -1) {
        this.activate_feature = child
        return 'item-activate'
      } else {
        return ''
      }
    },
    goSettingPage(item) {
      this.$router.push(`/${this.selectedOrg.org_id}/setting/${item.value}/`)
    },
    async getQuota(org_id) {
      let quotaVo = await this.getOrgSubscribtionInfo(org_id)
      let params = {
        org_id: org_id,
        quota: quotaVo,
      }
      this.$store.commit('update_member_quota', params)
      this.sidebar_org_id = org_id
    },
    getOrgSubscribtionInfo(org_id) {
      let result
      result = apiGetSubscriptionInfo(org_id)
        .then((resp) => {
          const { data } = resp
          return data.data
        })
        .catch((error) => {
          console.log(error)
          return []
        })
      return result
    },
    getOrganizeName(org_id) {
      let name = ''
      if (this.organize_container_mapper[org_id]) {
        name = this.organize_container_mapper[org_id].organization.org_name
      }
      return name
    },
    toggleDrawer() {
      this.drawer = !this.drawer
    },
    async showAllNotify() {
      this.notify_setting.page = 1
      this.notify_setting.items = []
      this.notify_setting.tab = 'unread'
      await this.getNotify()
      this.notify_setting.is_show = true
    },
    async getNotify(type, page) {
      if (!this.$route.params.container_id) {
        return
      }

      this.notify_setting.loading = true
      let read_type = this.notify_setting.tab
      if (read_type) {
        read_type = read_type === 'read' ? 1 : 0
      } else {
        read_type = 0
      }

      if (type) {
        read_type = type === 'read' ? 1 : 0
      }
      if (page) {
        this.notify_setting.page = page
      }
      try {
        const data = {
          container_id: this.$route.params.container_id,
          org: this.$route.params.org_id,
          page: this.notify_setting.page,
          limit: this.notify_setting.limit,
          is_read: read_type,
        }
        let result = await apiGetContainerNotifyV2(data)
        this.notify_setting.items = result.data.content
        if (read_type === 0) {
          this.notify_setting.total_size = result.data.totalElements
        }
        this.notify_setting.total_page = result.data.totalPages

        this.notify_setting.items = this.notify_setting.items.map((item) => {
          let timestamp = new Date(item.created_at).getTime()
          let created_at = this.$utils.getYYYYMMDDHHMMSS(item.created_at, '-')
          let trigger_from = ''
          if (item.type === 'dynamicViewError') {
            trigger_from = `${item.metadata.exp_name}`
          }
          return {
            timestamp: timestamp,
            created_at: created_at,
            feature_name: item.type,
            trigger_from: trigger_from,
            push_status: item.push_status,
            item: item,
          }
        })

        this.notify_setting.items.sort((a, b) => b.timestamp - a.timestamp)
      } catch (error) {
        console.error('notifys-error', error)
      }
      this.notify_setting.loading = false
    },
    notifyPageCallback(page_idx) {
      this.notify_setting.page = page_idx
    },
    goNotifyPlace(item) {
      let to_url = ''
      switch (item.feature_name) {
        case 'dynamicViewError':
          to_url = `/${item.item.metadata.org_id}/${item.item.metadata.container_id}/optimize_page/experiments/${item.item.metadata.exp_id}?tab=detail&vid=${item.item.metadata.vid}`
          break
        case 'loginFail':
          to_url = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_checkout/login`
          break
      }

      this.$router.push(to_url)
      this.notify_setting.is_show = false
    },
    async read(item) {
      item = item.item
      let is_read = confirm(this.$t('layout_appSidebar.confirmMarkAsHandled'))
      if (!is_read) {
        return
      }
      try {
        await apiReadNotify(this.$route.params.org_id, item.id)
      } catch (error) {
        console.error('read-error', error)
      }

      this.getNotify()
    },
    getRemainingdays(quota) {
      let sub_end_at = new Date(quota.sub_end_at).getTime()
      let now = new Date().getTime()
      let msDiff = sub_end_at - now // 還有多久（毫秒）
      let daysLeft = Math.floor(msDiff / (1000 * 60 * 60 * 24)) // 換算成天數，並無條件進位
      return daysLeft
    },
    checkShowFeature(item, user_info) {
      if (!item.meta) {
        return true
      }
      if (!item.meta.is_required_partner_user) {
        return true
      } else {
        if (user_info.is_beta_user || user_info.is_partner_user) {
          return true
        } else {
          return false
        }
      }
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('locale_lang', lang)
      this.$router.go(0)
    },
    async createSidebarItem() {
      // 根據後端紀錄的web_attribue來顯示側邊功能列表
      let is_container_user = this.$auth_helper.isContainerUser(this.user_info, this.selectedOrg.org_id)
      console.log('user_info', this.user_info)
      console.log('org_id', this.selectedOrg.org_id)
      console.log('is_container_user', is_container_user)
      if (!is_container_user) {
        this.routes = JSON.parse(JSON.stringify(private_routes))
        return
      }
      // 如果是身份是一般成員 or 容器成員才要做
      let tmp_routes = private_routes.filter((route) => {
        return route.invisibility_sidebar !== true
      })
      console.log('tmp_routes_1', tmp_routes)
      tmp_routes = JSON.parse(JSON.stringify(tmp_routes))
      tmp_routes.forEach((tmp_route) => {
        tmp_route.children = tmp_route.children.filter((children) => {
          return children.invisibility_sidebar !== true
        })
      })

      console.log('tmp_routes_2', JSON.parse(JSON.stringify(tmp_routes)))
      let check_auths = []
      tmp_routes.forEach((tmp_route) => {
        tmp_route.children.forEach((children) => {
          if (children.required_auth_rules) {
            check_auths = check_auths.concat(children.required_auth_rules)
          }
        })
      })

      console.log('check_auth', check_auths)

      if (!this.selectedContainer) {
        return
      }

      try {
        let payload = {
          org: this.selectedOrg.org_id,
          container: this.selectedContainer.id,
          api: check_auths,
        }
        let result = await apiUseApiAuth(payload)
        tmp_routes.forEach((tmp_route) => {
          tmp_route.children.forEach((children) => {
            if (children.required_auth_rules) {
              let is_auth = children.required_auth_rules.every((required_auth_rule) => {
                const match = result.find(
                  (result_item) =>
                    result_item.url === required_auth_rule.url && result_item.method === required_auth_rule.method
                )
                return match && match.enable === true
              })
              children.is_auth = is_auth
            }
          })
        })

        tmp_routes.forEach((tmp_route) => {
          tmp_route.children = tmp_route.children.filter((children) => {
            return children.is_auth || !children.required_auth_rules
          })
        })
        tmp_routes = tmp_routes.filter((tmp_route) => {
          return tmp_route.children.length > 0
        })
        this.routes = JSON.parse(JSON.stringify(tmp_routes))
      } catch (error) {
        console.log('error', error)
      }
      console.log('tmp_routes', this.routes)
    },
  },
}
</script>

<style scoped lang="scss">
:deep(#nav-drawer .v-navigation-drawer__content) {
  position: relative;
}

:deep(#nav-drawer .v-navigation-drawer__content > :last-child) {
  position: absolute;
  bottom: 8px;
  width: calc(100% - 16px);
  margin-left: 8px;
  margin-right: 8px;
  border-radius: 5px;
  font-size: 13px;
}

.item-activate {
  background: #fff;
}

.item-activate-text {
  color: #353f4d !important;
}

.item-activate-text-background {
  background-color: #353f4d !important;
}

.btn-danger {
  background: #e3262e;
  background-image: linear-gradient(180deg, #e3262e, #ab171e);
  color: #fff;
  border: 1px solid #ab171e;
  text-decoration: none;
  min-width: 40px;
  box-shadow: inset 0 1px 1px #ff7b81, 0 2px 2px -1px rgba(0, 0, 0, 0.2);
}

.parent-item,
.sub-item:hover {
  transition: all 0.2s;
}

.parent-item:hover,
.sub-item:hover {
  background-color: rgba(54, 62, 77, 0.2);
}

.v-list-item--dense .v-list-item__content,
.v-list--dense .v-list-item .v-list-item__content {
}

// 蓋掉 vuetify 預設
::v-deep .lang-selector {
  .v-input__slot {
    box-shadow: none !important;
    .v-select__selection {
      max-width: 100%;
    }
  }
  input {
    display: none;
  }
}
</style>
